import { ButtonLink } from '@repo/ui';
import { GetUsersOnlineInterface } from 'domain/usecases';
import { useService } from 'presentation/app/hooks/useService';
import { useAppSelector } from 'presentation/config/hooks/useRedux';
import { loadUsersOnlineListData } from 'presentation/config/store/users/users-online/users-online-slice';
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Col, Dropdown, DropdownMenu, DropdownToggle, Row } from 'reactstrap';

//import images
import SimpleBar from 'simplebar-react';

//SimpleBar

export const UsersOnlineHeaders = () => {
  // hooks
  const navigate = useNavigate();
  const { usersService } = useService();
  const dispatch = useDispatch();

  const { usersOnline } = useAppSelector((state) => state.usersOnline);

  // functions
  const now = new Date();

  //Dropdown Toggle
  const [isNotificationDropdown, setIsNotificationDropdown] =
    useState<boolean>(false);
  const toggleNotificationDropdown = () => {
    setIsNotificationDropdown(!isNotificationDropdown);
  };

  const requestUsersOnline = useCallback(
    async (params?: GetUsersOnlineInterface.Params) => {
      return usersService
        .getUsersOnline(params)
        .then((res) => {
          dispatch(loadUsersOnlineListData(res));
        })
        .catch((err) => {});
    },
    [],
  );

  useEffect(() => {
    requestUsersOnline({ limit: '10' });

    const fetchData = () => {
      requestUsersOnline({ limit: '10' });
    };

    const intervalId = setInterval(fetchData, 1000 * 60);

    return () => clearInterval(intervalId);
  }, []);

  return (
    <React.Fragment>
      <Dropdown
        isOpen={isNotificationDropdown}
        toggle={toggleNotificationDropdown}
        className="topbar-head-dropdown ms-1 header-item"
      >
        <DropdownToggle
          type="button"
          tag="button"
          className="btn btn-icon btn-topbar btn-ghost-primary rounded-circle"
        >
          <i className="ri-group-line fs-22"></i>
        </DropdownToggle>
        <DropdownMenu className="dropdown-menu-lg dropdown-menu-end p-0">
          <div
            style={{ backgroundColor: '#144c5bed' }}
            className="dropdown-head bg-pattern rounded-top"
          >
            <div className="p-3">
              <Row className="align-items-center">
                <Col>
                  <h6 className="m-0 fs-16 fw-semibold text-white">
                    Usuários on-line
                  </h6>
                </Col>
                <div className="col-auto dropdown-tabs">
                  <span className="badge bg-light-subtle text-body fs-13">
                    {usersOnline?.count}
                  </span>
                </div>
              </Row>
            </div>
          </div>

          <SimpleBar
            style={{ maxHeight: '350px', marginBottom: '50px' }}
            className="overflow-y"
          >
            {usersOnline?.users?.map((user) => {
              const lastAccessDate = new Date(user.last_access);
              const timeLoggedInMs = now.getTime() - lastAccessDate.getTime();

              const hours = Math.floor(timeLoggedInMs / (1000 * 60 * 60));
              const minutes = Math.floor(
                (timeLoggedInMs % (1000 * 60 * 60)) / (1000 * 60),
              );

              const formattedTimeLoggedIn = `${hours}h ${minutes}m`;
              return (
                <div
                  className="text-reset notification-item d-block dropdown-item position-relative"
                  key={user.id}
                >
                  <div className="d-flex">
                    <div className="d-flex me-3 justify-content-center align-items-center">
                      {user.avatar ? (
                        <img
                          className="rounded-circle avatar"
                          src={user.avatar}
                          alt="photo"
                        />
                      ) : (
                        <div
                          className="rounded-circle d-flex justify-content-center align-items-center"
                          style={{
                            width: '45px',
                            height: '45px',
                            backgroundColor: '#144c5bed',
                          }}
                        >
                          <span className="text-white fs-5 fw-bold">
                            <i className="ri-user-line"></i>
                          </span>
                        </div>
                      )}
                    </div>

                    <div className="flex-grow-1">
                      <h6 className="mt-0 mb-1 fs-13 fw-semibold d-flex justify-content-between">
                        <span>{user.name}</span>
                        <span
                          className="text-primary"
                          style={{ fontSize: '10px' }}
                        >
                          {user?.platform}
                        </span>
                      </h6>

                      <p className="mb-0 fs-11 fw-medium text-uppercase text-muted">
                        <span>
                          <i className="mdi mdi-clock-outline"></i>{' '}
                          {!hours && !minutes
                            ? 'Menos de um minuto'
                            : formattedTimeLoggedIn}
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
              );
            })}

            <div
              style={{
                backgroundColor: 'white',
                position: 'fixed',
                bottom: 0,
                right: 0,
                left: 0,
              }}
              className="pt-2 pb-2  text-center border-top"
            >
              <ButtonLink
                onClick={() => {
                  navigate('/usuarios-online');
                }}
              >
                Ver todos
              </ButtonLink>
            </div>
          </SimpleBar>
        </DropdownMenu>
      </Dropdown>
    </React.Fragment>
  );
};
